import {
  StyledTextInput,
  InputWrapper,
  StyledWrappedInput,
  Affix,
} from './InputText.styled';

const InputText = ({
  id,
  value,
  onChange,
  type = 'number',
  prefix,
  suffix,
  ...rest
}) => {
  const handleChange = (e) => {
    if (type === 'number') {
      const numVal = Number(e.target.value);
      const parsed = !isNaN(numVal) && e.target.value !== '' ? numVal : null;
      onChange(parsed);
    } else {
      onChange(e.target.value);
    }
  };

  if (prefix || suffix) {
    return (
      <InputWrapper
        width={rest.width}
        height={rest.height}
        disabled={rest.disabled}
        question={rest.question}
      >
        {prefix && <Affix>{prefix}</Affix>}
        <StyledWrappedInput
          id={id}
          value={value ?? ''}
          onChange={handleChange}
          {...rest}
        />
        {suffix && <Affix>{suffix}</Affix>}
      </InputWrapper>
    );
  }

  return (
    <StyledTextInput id={id} value={value ?? ''} onChange={handleChange} {...rest} />
  );
};

export default InputText;
